module.exports = __webpack_public_path__ + "static/img/zncrm.705bd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zncrm.png
// module id = Tt8A
// module chunks = 0